import { render } from "./InputWeek.vue?vue&type=template&id=9bac219e"
import script from "./InputWeek.vue?vue&type=script&lang=js"
export * from "./InputWeek.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__